<template>
  <div class="search-wrap">
    <el-input type="text" placeholder="请输入内容" v-model.trim="searchdata" @keyup.enter.native="searchEnterFun($event)" show-word-limit>
    </el-input>

    <el-button type="primary" @click="btnSearch" class="btn-wrap">搜索</el-button>
  </div>
</template>

<script>
export default {
  props: {
    
  },
  data() {
    return {
      searchdata: "",
      timer: null
    }
  },
  methods: {
    btnSearch() {
      if(this.searchdata === '' ){
        return
      }
      this.timer = setTimeout(()=>{
        this.$emit('search', this.searchdata)
      },100)
    },
    searchEnterFun(e) {
       if(!this.searchdata){
        return
      }
      this.$emit('searchEnter',e,this.searchdata)
    }
  },
}
</script>

<style lang="scss" scoped>
.search-wrap {
  display: flex;
  flex-wrap: nowrap;

  //   .button-wrap {
  //     width: 80px;
  //     line-height: 50px;
  //     border-radius: 42px;
  //     background: linear-gradient(225deg, #0c09cf, #0e0bf6);
  //     box-shadow: -18px 18px 35px #0a07aa, 18px -18px 35px #100dff;
  //   }
  .btn-wrap {
    margin-left: 5px;
    font-weight: bold;
    background-color: rgb(7, 22, 116);
    border-color: rgb(7, 22, 116);
    //   text-align: justify;   // 未生效
  }
}
</style>
